import { Script } from 'gatsby';
import React, { useEffect, useMemo, useState } from 'react';
import { usePageContext } from '../../hooks/contexts/usePageContext';
import * as styles from './widgetResa.module.scss';

interface IWidgetDispoResaProps {
  codePrestation: string;
  enableResa?: boolean;
  waitForWindowLoad?: boolean;
}

const makeConfigWidget = (
  lang: string,
  codePrestation: string,
  enableResa: boolean,
  elementHtmlIdDispo: string,
  elementHtmlIdResa: string,
  waitForWindowLoad: boolean
) => ({
  el: elementHtmlIdDispo, // id de la div pour faire apparaître le widget de dispo
  site: {
    code: 'RESA',
    url:
      lang === 'en' ? 'https://booking.tours-tourisme.fr' : 'https://reservation.tours-tourisme.fr',
  },
  object: {
    code: codePrestation, // Code de la prestation/prestataire
  },
  options: {
    templates: {
      Week: 'semaineLigne',
      Days: 'jourSemaineLigne',
    },
  },
  booking: {
    enable: enableResa, // false
    parameters: {
      waitForWindowLoad,
      idWidget: elementHtmlIdResa, // id de la div pour faire apparaître le widget de résa
    },
  },
});

/**
 * you have to call it before WidgetDispoResaInstance
 *
 * @param param0
 * @returns
 */
export const WidgetDispoDiv = ({ codePrestation }) => {
  const elementHtmlIdDispo = `widget-dispo-ingenie-ot-${codePrestation}`;
  return <div className={styles.wrapper} id={elementHtmlIdDispo} />;
};

/**
 * you have to call it before WidgetDispoResaInstance
 *
 * @param param0
 * @returns
 */
export const WidgetResaDiv = ({ codePrestation }) => {
  const elementHtmlIdResa = `widget-resa-ingenie-ot-${codePrestation}`;
  return <div id={elementHtmlIdResa} className={styles.wrapper} />;
};

export const WidgetDispoResaInstance = ({
  codePrestation,
  enableResa = true,
  waitForWindowLoad = false,
}: IWidgetDispoResaProps) => {
  const { lang } = usePageContext();
  const [scriptClientLoad, setscriptClientLoad] = useState<boolean>(false);
  const [scriptLoaderLoad, setscriptLoaderLoad] = useState<boolean>(false);
  const [scriptClientDispoLoad, setscriptClientDispoLoad] = useState<boolean>(false);
  const elementHtmlIdResa = `widget-resa-ingenie-ot-${codePrestation}`;
  const elementHtmlIdDispo = `widget-dispo-ingenie-ot-${codePrestation}`;
  const config = useMemo(
    () =>
      makeConfigWidget(
        lang,
        codePrestation,
        enableResa,
        elementHtmlIdDispo,
        elementHtmlIdResa,
        waitForWindowLoad
      ),
    [codePrestation, enableResa, elementHtmlIdDispo, elementHtmlIdResa, waitForWindowLoad, lang]
  );

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      scriptClientLoad &&
      scriptLoaderLoad &&
      scriptClientDispoLoad
    ) {
      const widget = new window.IngenieWidgetDispo.Client({ ...config });
      widget.init();
    }
  }, [config, scriptClientDispoLoad, scriptClientLoad, scriptLoaderLoad]);

  return (
    <>
      <Script
        onLoad={() => setscriptClientLoad(true)}
        type="text/javascript"
        src="https://static.ingenie.fr/js/widgets/resa/IngenieWidgetResaClient.js"
      />
      <Script
        onLoad={() => setscriptLoaderLoad(true)}
        src="https://static.ingenie.fr/js/ScriptsLoader.js"
        type="application/javascript"
      />
      <Script
        onLoad={() => setscriptClientDispoLoad(true)}
        src="https://static.ingenie.fr/widgets/dispo/js/Client.js"
        type="application/javascript"
      />
    </>
  );
};
